var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-block"},[_c('canvas',{attrs:{"id":"myChart","width":"440","height":"320"}})])}]

export { render, staticRenderFns }